// api urls and static data urls will be here
import { get_access_token } from "./auth";
export const access_token = get_access_token();
export const configApi = "appconfig/pdWebapp/";
export const Base = "https://testapi.punnyadhara.com/";
export const Fandu = "https://api.thefandu.com/api/";
// export const Fandu = "http://192.168.100.119:3000/api/";

export const Base3 = "https://api.punnyadhara.com/";

export const Base2 = "https://app.punnyadhara.com/";
// export const Base2 = "http://localhost:3000/";
export const checkout = "https://checkout.punnyadhara.com/checkout/";
export const imgUrl =
  "https://objectstorage.ap-mumbai-1.oraclecloud.com/n/bmnkoulqjlqv/b/prod-punnyadhara-cdn/o/offer_images/";
export const vmImgUrl =
  "https://objectstorage.ap-mumbai-1.oraclecloud.com/n/bmnkoulqjlqv/b/prod-punnyadhara-cdn/o/vm_products";
export const hdImgUrl =
  "https://objectstorage.ap-mumbai-1.oraclecloud.com/n/bmnkoulqjlqv/b/prod-punnyadhara-cdn/o/hotdeal_products/";
export const categoryImgUrl =
  "https://objectstorage.ap-mumbai-1.oraclecloud.com/n/bmnkoulqjlqv/b/prod-punnyadhara-cdn/o/quiz_categories/";
export const rewardsImgUrl =
  "https://objectstorage.ap-mumbai-1.oraclecloud.com/n/bmnkoulqjlqv/b/prod-punnyadhara-cdn/o/rewards_images/";
export const fanduBannerImgUrl =
  "https://objectstorage.ap-mumbai-1.oraclecloud.com/n/bmnkoulqjlqv/b/prod-punnyadhara-cdn/o/fandu_feed_banners/";
